import {Controller} from "stimulus";
import noUiSlider from "nouislider";
import 'nouislider/dist/nouislider.css';

export default class extends Controller {
    static targets = ["sliderContainer", "minInput", "maxInput", 'pips'];

    connect() {
        this.setupDone = false;
        this.setupBedroomsSlider();
    }

    setupBedroomsSlider() {
        const minValue = this.minInputTarget.value ? parseInt(this.minInputTarget.value) : this.pips[0];
        const maxValue = this.maxInputTarget.value ? parseInt(this.maxInputTarget.value) : this.pips[this.pips.length - 1];

        // Create the range slider
        noUiSlider.create(this.sliderContainerTarget, {
            start: [minValue, maxValue],
            range: this.range,
            connect: true,
            tooltips: true,
            step: null,
            snap: true,
            format: {
                to: function (value) {
                    return Math.round(value);
                },
                from: function (value) {
                    return Number(value);
                }
            },
            pips: {
                mode: 'values',
                values: this.pips,
                filter: this._pipFilter.bind(this),
                density: 4,
                stepped: true,
            },
        });

        this.sliderContainerTarget.noUiSlider.on('update.one', this._updateInputs.bind(this));
    }

    // Function to calculate pip values based on the range
    get pips() {
        return Array.from(this.pipsTarget.options)
            .map(option => Number(option.value));
    }

    _pipFilter(value, type) {
        return this.pips.includes(value) ? 1 : -1;
    }

    get range() {
        if (!this._range) {
            this._range = this.pips.reduce((acc, step, index) => {
                const percentage = (index / (this.pips.length - 1)) * 100; // Calcula a posição proporcional
                switch (percentage) {
                    case 0:
                        acc['min'] = step;
                        break
                    case 100:
                        acc['max'] = step;
                        break;
                    default:
                        acc[`${percentage}%`] = step;
                }

                return acc;
            }, {});
        }

        return this._range
    }

    _updateInputs(values, handle) {
        if (!this.setupDone && handle === 0) return;
        if (!this.setupDone && handle === 1) {
            this.setupDone = true;
            return;
        }

        const [minBedrooms, maxBedrooms] = values.map(Number);

        if (handle === 0) {
            this.minInputTarget.value = minBedrooms;
            this.minInputTarget.dispatchEvent(new Event('change'));
        } else {
            this.maxInputTarget.value = maxBedrooms;
            this.maxInputTarget.dispatchEvent(new Event('change'));
        }
    }
}